import React, { useId } from 'react';
import IconWrap, { Props as WrapperProps } from '../IconWrap';

export interface Props extends WrapperProps {}

const VideoCreatorGradientLogo: React.FC<Props> = props => {
  const uniqueId = useId();

  return (
    <IconWrap {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="30"
        viewBox="0 0 32 30"
        fill="none"
      >
        <defs>
          <linearGradient
            id={`video-creator-gradient-logo-${uniqueId}`}
            x1="2"
            x2="22.538"
            y1="14.125"
            y2="-2.802"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#c546a8" />
            <stop offset="1" stopColor="#713cde" />
          </linearGradient>
        </defs>
        <path
          fill={`url(#video-creator-gradient-logo-${uniqueId})`}
          d="M28.825 9.214c.649 0 1.174.43 1.174.958v16.12c0 .529-.525.958-1.174.958H10.373c-.649 0-1.176-.429-1.176-.958V16.32c0-.016.015-.979.147-1.464.512-1.81 1.478-3.072 2.695-3.939.928-.661 2.187-1.208 3.95-1.562.547-.11 1.638-.14 1.664-.141zm-11.108 4.682c-.649 0-1.184.436-1.258.998l-.009.131v7.341c.2.101.26.3.175.573.529.4 1.021.69 1.6.461l.132-.06 5.996-3.671c.385-.197.539-.335.448-.4.528-.6.379-1.232-.326-1.473l-.123-.072-5.995-3.672c.006-.201-.415-.155-.64-.155M7.667 2.75a.13.13 0 0 1 .118.114c.585 2.89 2.246 4.715 5.402 5.22a.13.13 0 0 1 .117.096l.003.012v.003l.002.008v.022l-.002.003-.001.01a.13.13 0 0 1-.117.1c-3.158.506-4.82 2.33-5.404 5.222a.13.13 0 0 1-.127.113h-.016a.13.13 0 0 1-.119-.114c-.583-2.89-2.246-4.715-5.402-5.22a.13.13 0 0 1-.117-.097L2 8.232v-.003L2 8.219V8.2l.001-.004.002-.01a.13.13 0 0 1 .116-.1C5.277 7.58 6.94 5.754 7.523 2.862a.13.13 0 0 1 .115-.112z"
        />
      </svg>
    </IconWrap>
  );
};

VideoCreatorGradientLogo.displayName = 'VideoCreatorGradientLogo';

export default VideoCreatorGradientLogo;
